import React from "react"

import { isLTPM } from "../../../../components/shared_components_registration"

// Used on only LTPM side currently
export default function PriorityIcon({ priority, intl, extraStyle = {} }) {
  let className = "fa fa-check"
  let title = isLTPM
    ? `${intl.formatMessage({ id: "general.priority" })}: ${intl.formatMessage({
        id: "general.priority.normal",
      })}`
    : "Priority: Normal"
  if (priority === "CRIT") {
    className = "fa fa-exclamation-triangle"
    title = isLTPM
      ? `${intl.formatMessage({ id: "general.priority" })}: ${intl.formatMessage({
          id: "general.priority.critical",
        })}`
      : "Priority: Critical"
  }
  return <span className={className} style={{ textAlign: "center", ...extraStyle }} title={title} />
}
